/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataCampaignsQueryResponse, AuditReportsGetGipMetadataCampaignsQueryParams, AuditReportsGetGipMetadataCampaigns401, AuditReportsGetGipMetadataCampaigns403 } from "../models/AuditReportsGetGipMetadataCampaigns";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetGipMetadataCampaigns } from "../axios/auditReportsGetGipMetadataCampaigns";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetGipMetadataCampaignsQueryKey = (params: AuditReportsGetGipMetadataCampaignsQueryParams) => ["api-v2", { url: '/audit-reports/v1/reports/gip/metadata/campaigns' }, ...(params ? [params] : [])] as const

export type AuditReportsGetGipMetadataCampaignsQueryKey = ReturnType<typeof auditReportsGetGipMetadataCampaignsQueryKey>

export function auditReportsGetGipMetadataCampaignsQueryOptions(params: AuditReportsGetGipMetadataCampaignsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetGipMetadataCampaignsQueryKey(params)
        return queryOptions<AuditReportsGetGipMetadataCampaignsQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataCampaigns401 | AuditReportsGetGipMetadataCampaigns403>, AuditReportsGetGipMetadataCampaignsQueryResponse, typeof queryKey>({
         enabled: !!(params),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetGipMetadataCampaigns(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Return GIP campaigns for stations in a range
 * {@link /audit-reports/v1/reports/gip/metadata/campaigns}
 */
export function useAuditReportsGetGipMetadataCampaigns<TData = AuditReportsGetGipMetadataCampaignsQueryResponse, TQueryData = AuditReportsGetGipMetadataCampaignsQueryResponse, TQueryKey extends QueryKey = AuditReportsGetGipMetadataCampaignsQueryKey>(params: AuditReportsGetGipMetadataCampaignsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetGipMetadataCampaignsQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataCampaigns401 | AuditReportsGetGipMetadataCampaigns403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetGipMetadataCampaignsQueryKey(params)
         

         const query = useQuery({
          ...auditReportsGetGipMetadataCampaignsQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetGipMetadataCampaigns401 | AuditReportsGetGipMetadataCampaigns403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}